import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  code: {
    display: 'block',
    padding: '12px 14px',
    borderRadius: token.borderRadiusSM,
    background: token.colorFillTertiary,
    border: `1px solid ${token.colorBorderSecondary}`,
    fontFamily: token.fontFamilyCode,
    fontSize: 12,
    lineHeight: 1.6,
    color: token.colorText,
    whiteSpace: 'pre',
    overflowX: 'auto',
    margin: 0
  },
  tips: {
    listStyle: 'disc',
    paddingInlineStart: 20,
    margin: 0,
    color: token.colorTextSecondary,
    fontSize: 12,
    lineHeight: 1.7
  }
}))
